import { SAVECHAT } from "./chatManagerActions";

const INITIAL_STATE = {
  room: [],
};

const saveChatReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SAVECHAT:
      return {
        ...state,
        room: [...state.room, action.payload],
      };

    default:
      return state;
  }
};

export default saveChatReducer;